<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        tableTypeOptions: [], // 费用类型
        paymentWayOptions: [], // 支付方式
        form: [
          { // 费用类型
            label: '费用类型',
            value: 'tableType',
            type: 'select',
            default: -1,
            placeholder: '请选择费用类型',
          },
          { // 订单号码
            label: '订单号码',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 司机姓名
            label: '司机姓名',
            value: 'carDriverMan',
            type: 'input',
            placeholder: '请输入司机姓名',
          },
          { // 上报时间
            label: '上报时间',
            value: 'subDate',
            type: 'date',
            default: [],
            placeholder: '请选择上报时间',
            attr: {
              type: 'daterange',
              clearable: true,
            },
          },
          { // 支付方式
            label: '支付方式',
            value: 'paymentWay',
            type: 'select',
            default: -1,
            placeholder: '请选择支付方式',
          },
          { // 卡号/油站
            label: '卡号/油站',
            value: 'cardNo',
            type: 'input',
            placeholder: '请输入卡号/油站',
          },
          { // 备注
            label: '备注',
            value: 'remark',
            type: 'input',
            placeholder: '请输入备注',
          },
          { // 发车时间
            label: '发车时间',
            value: 'dependTime',
            default: [],
            type: 'date',
            placeholder: '请选择发车时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 线路名称
            label: '线路名称',
            value: 'sourceName',
            type: 'input',
            placeholder: '请输入线路名称',
          },
          { // 司机手机
            label: '司机手机',
            value: 'carDriverPhone',
            type: 'input',
            placeholder: '请输入司机手机',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.subDate && searchBoxData.subDate.length) {
        searchBoxData.subDateStart = this.formatDate(searchBoxData.subDate[0]);
        searchBoxData.subDateEnd = this.formatDate(searchBoxData.subDate[1]);
      }
      delete searchBoxData.subDate;
      if (searchBoxData.dependTime && searchBoxData.dependTime.length) {
        searchBoxData.dependTimeStart = this.formatDate(searchBoxData.dependTime[0]);
        searchBoxData.dependTimeEnd = this.formatDate(searchBoxData.dependTime[1]);
      }
      delete searchBoxData.dependTime;
      this.$refs.tableBox.saveSearchBoxData({
        orgId: -1,
        rootOrgId: -1,
        endTime: this.formatDate(new Date()),
        ...searchBoxData,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'REPORT_TABLE_TYPE,REPORT_PAYMENT_WAY',
    });
    this.searchBoxData.tableTypeOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.searchBoxData.paymentWayOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
